<script setup lang="ts">
  export interface TabItemProps {
    label: string
    selected?: boolean
    design?: 'msn' | 'google'
  }

  const { t } = useI18n()

  const props = withDefaults(defineProps<TabItemProps>(), {
    selected: false,
    design: 'google',
  })

  const labelClasses = computed(() => {
    if (props.selected && props.design === 'msn')
      return 'text-action-neutral-selected'
    if (props.selected && props.design === 'google')
      return 'text-action-primary-selected'
    else
      return 'text-action-neutral-default group-hover:text-action-neutral-hover'
  })
</script>
<template>
  <button
    class="group w-fit"
    :class="{
      'rounded-8px border px-12px py-6px flex items-center': design === 'msn',
      'border-transparent': design === 'msn' && !selected,
      'border-border-neutral-subtle bg-action-neutral-onSubtle-default':
        design === 'msn' && selected,
    }"
    data-testid="tab-item"
  >
    <Typography
      :variant="design === 'msn' ? 'text-sm' : 'text-base'"
      weight="font-medium"
      class="leading-[20px] whitespace-nowrap"
      :color="labelClasses"
      element="span"
    >
      {{ t(label) }}
    </Typography>
    <div
      v-if="design === 'google'"
      data-testid="tab-border"
      class="mt-8px h-4px w-full rounded-tl-6px rounded-tr-6px"
      :class="selected ? 'bg-border-interaction-selected' : 'transparent'"
    />
  </button>
</template>
